import Vue from "vue";
import Router from "vue-router";
import dashBoard from "../paginas/Dashboard.vue";
import store from "./store";
import { perfis, paginasChefia, perfisAdm } from "@/config/global";

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/" + process.env.VUE_APP_BASE_URL + "/auth",
      name: "auth",
      component: () => import("@/paginas/login/Login.vue"),
    },
    {
      path: "/" + process.env.VUE_APP_BASE_URL,
      component: () => import("@/App.vue"),
      children: [
        {
          path: "",
          name: "inicio",
          component: dashBoard,
        },
        {
          path: "formDeclaracao",
          name: "formDeclaracaoBens",
          component: () =>
            import("@/paginas/declaracaoBens/declaracaoBens.vue"),
        },
        {
          path: "formDeclaracao/edit/:id",
          name: "formDeclaracaoBensEdit",
          component: () =>
            import("@/paginas/declaracaoBens/declaracaoBens.vue"),
        },
        {
          path: "visualizar/:id",
          name: "formDeclaracaoBensVisualizar",
          component: () =>
            import("@/paginas/visualizaDeclaracao/declaracaoBensView.vue"),
        },
        {
          path: "cadastro/usuario",
          name: "cadastroUsuario",
          component: () =>
            import("@/paginas/cadastro/usuario/CadastroUsuario.vue"),
        },
        {
          path: "cadastro/usuario/novo",
          name: "usuario-container",
          component: () =>
            import("@/paginas/cadastro/usuario/ContainerUsuario.vue"),
        },
        {
          path: "cadastro/usuario/dados",
          name: "usuario-dados",
          component: () =>
            import("@/paginas/cadastro/usuario/TabPanelDados.vue"),
        },
        {
          path: "cadastro/usuario/novo/vinculos",
          name: "usuario-vinculos",
          component: () =>
            import("@/paginas/cadastro/usuario/TabPanelVinculos.vue"),
        },
        {
          path: "cadastro/usuario/perfil",
          name: "usuario-perfil",
          component: () =>
            import("@/paginas/cadastro/usuario/TabPanelPerfilAcesso.vue"),
        },
        {
          path: "cadastro/usuario/fiscal",
          name: "usuario-fiscal",
          component: () =>
            import(
              "@/paginas/cadastro/usuario/TabPanelPerfilAcessoFiscalizador.vue"
            ),
        },
        {
          path: "cadastro/perfil",
          name: "cadastroPerfilUsuario",
          component: () =>
            import("@/paginas/cadastro/perfil/CadastroPerfil.vue"),
        },
        {
          path: "cadastro/acesso/fiscal",
          name: "atribuirAcessoFiscal",
          component: () =>
            import("@/paginas/cadastro/fiscal/AtribuirAcessoFiscal.vue"),
        },
        {
          path: "cadastro/exercicio",
          name: "cadastroExercicio",
          component: () =>
            import("@/paginas/cadastro/exercicio/CadastroExercicio.vue"),
        },
        {
          path: "cadastro/teste",
          name: "teste",
          component: () => import("@/paginas/cadastro/Teste.vue"),
        },
        /*   {
            path: 'modulo-rh/validarArquivo',
            component: () =>
              import('@/paginas/modulo_rh/validarArquivo/ValidarArquivo.vue'),
          }, */
        {
          path: "modulo-rh/acompanharDeclaracao",
          component: () =>
            import(
              "@/paginas/modulo_rh/acompanharDeclaracao/AcompanharDeclaracao.vue"
            ),
        },
        {
          path: "modulo-rh/retificacao/lista",
          name: "listaRetificaca",
          component: () =>
            import(
              "@/paginas/modulo_rh/retificacaoDelcaracao/listaRetificacao.vue"
            ),
        },
        {
          path: "modulo-rh/retificacao",
          name: "retificacaoDeclaracao",
          component: () =>
            import(
              "@/paginas/modulo_rh/retificacaoDelcaracao/retificacaoArqFederal.vue"
            ),
        },
        {
          path: "fiscalizacao",
          component: () => import("@/paginas/fiscalizacao/Fiscalizacao.vue"),
        },
        {
          path: "relatorio/consolidado/orgao",
          name: "relatorio",
          component: () =>
            import("@/paginas/relatorio/RelatorioConsolidado.vue"),
        },
        {
          path: "relatorio/consolidado/vinculo",
          name: "consolidadoVinculo",
          component: () =>
            import("@/paginas/relatorio/RelatorioConsolidadoVinculo.vue"),
        },
        {
          path: "log/auditoria",
          name: "auditoria",
          component: () => import("@/paginas/log/auditoria.vue"),
        },
      ],
    },
  ],
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});
router.beforeEach(async (to, from, next) => {
  var dataToken = null;

  // if (localStorage.getItem(process.env.VUE_APP_USER_KEY)) {
  //   dataToken = JSON.parse(
  //     atob(localStorage.getItem(process.env.VUE_APP_USER_KEY))
  //   );
  //}

  if (localStorage.getItem(process.env.VUE_APP_USER_KEY)) {
    let dadosStorageSeplagJson = decodeURI(
      atob(localStorage.getItem(process.env.VUE_APP_USER_KEY))
    );
    dataToken = JSON.parse(dadosStorageSeplagJson);
  }

  if (dataToken) {
    if (!store.getters.isUserLogado) {
      store.commit("setUserLogado", true);
    }
    if (!store.getters.getToken) {
      store.commit("setToken", JSON.stringify(dataToken.token));
    }
    if (!store.getters.getUser) {
      await store.dispatch("buscarUsuario", Vue.prototype);
    }
  }

  if (to.meta.requiresAuth == false) {
    next();
  } else if (store.getters.getUser) {
    let perfilUsers = store.getters.getUser.contaAcesso.direitosDinamicos;
    let possuiAcesso = false;
    if (perfilUsers.length <= 0) {
      let verifica = paginasChefia.filter(function(element) {
        return element == to.name;
      });
      if (!verifica || verifica.length <= 0) {
        possuiAcesso = true;
      }
    } else {
      for (let i = 0; i < perfilUsers.length; i++) {
        let permissao = perfis.filter(function(element) {
          return element.perfil == perfilUsers[i].nomeRole;
        });
        if (permissao.length > 0) {
          let verifica = permissao[0].permissoes.filter(function(element) {
            possuiAcesso = true;
            return element == to.name;
          });
          if (verifica && verifica.length > 0) {
            possuiAcesso = true;
            break;
          }
        }
      }
    }
    if (possuiAcesso) {
      next();
    } else {
      //VALIDACAO AUTORIDADES
      perfilUsers = store.getters.getUser.contaAcesso.authorities;
      if (perfilUsers && perfilUsers.length > 0) {
        for (let i = 0; i < perfilUsers.length; i++) {
          let permissao = perfisAdm.filter(function(element) {
            return element.perfil == perfilUsers[i].nomeRole;
          });
          if (permissao.length > 0) {
            let verifica = permissao[0].permissoes.filter(function(element) {
              return element == to.name;
            });
            if (verifica && verifica.length > 0) {
              possuiAcesso = true;
              break;
            }
          }
        }
      }
      if (possuiAcesso) {
        next();
      } else {
        Vue.prototype.$toast.add({
          severity: "error",
          summary: "Você não possui permissão para acessar essa página.",
          life: 10000,
        });
        next({ name: "app" });
      }
    }
    next();
  } else {
    if (to.name !== "auth")
      next({ name: "auth", query: { redirect: to.fullPath } });
    else next();
  }
});
export default router;
